import { UtilDocumentId } from '../utils/UtilDocumentId';
import { BehaviorSubject } from 'rxjs';
// taken from @angular/common/http
var HttpEventType;
(function (HttpEventType) {
    HttpEventType[HttpEventType["Sent"] = 0] = "Sent";
    HttpEventType[HttpEventType["UploadProgress"] = 1] = "UploadProgress";
    HttpEventType[HttpEventType["Response"] = 4] = "Response";
    HttpEventType[HttpEventType["User"] = 5] = "User";
})(HttpEventType || (HttpEventType = {}));
/**
 * Describes that upload has started
 */
export class UploadStart {
}
/**
 * Describes that upload has made progress
 *
 * @property uploaded how many bytes have been uploaded
 *
 * @property total Total number of bytes to upload. The total field may be undefined, if the total number of bytes is not known. This data is provided by the http client
 */
export class Progress {
    constructor(uploaded, total) {
        this.uploaded = uploaded;
        this.total = total;
    }
    /**
     * Progress as percentage
     */
    percentage() {
        if (this.total === undefined) {
            return null;
        }
        return (this.uploaded / this.total) * 100;
    }
}
/**
 * Describes that upload has completed
 */
export class Finished {
    constructor(response) {
        this.response = response;
    }
}
export class UploaderService {
    constructor(file, documentId) {
        this.file = file;
        this.documentId = documentId;
        this.fileProviderService = window.FormbirdServiceInjector.get('FileProviderService');
        this.subject = new BehaviorSubject(undefined);
        this.upload();
    }
    upload() {
        const fileNo = UtilDocumentId.generateId();
        const uploadData = {
            fileNo: fileNo,
            file: this.file,
            documentId: this.documentId
        };
        const uploader = this.fileProviderService.uploadFile(uploadData);
        this.sub = uploader.subscribe((event) => {
            switch (event.type) {
                case HttpEventType.Sent:
                    this.subject.next(new UploadStart());
                    break;
                case HttpEventType.Response:
                    this.subject.next(new Finished(event.body));
                    this.subject.complete();
                    break;
                case HttpEventType.UploadProgress:
                    this.subject.next(new Progress(event.loaded, event.total));
                    break;
            }
        }, (error) => {
            this.subject.error(error);
        });
    }
    /**
     * Return an observable which reports progress of the file upload
     */
    get observable() {
        return this.subject.asObservable();
    }
    /**
     * Stop the upload and clear state
     */
    destroy() {
        this.sub.unsubscribe();
        this.subject.complete();
    }
    /**
     * Returns a promise that is resolved when the file uploads completes
     */
    asPromise() {
        return new Promise((resolve, reject) => {
            this.observable.subscribe((event) => {
                if (event instanceof Finished) {
                    resolve(event.response);
                }
            }, error => reject(error));
        });
    }
}
